import { Box } from "@mui/material";
import {  useEffect } from "react";
import { useTranslation } from "react-i18next";
import Cookies from "universal-cookie";
import { useSelector } from "react-redux";

export default function SorryPage() {
  const maintheme = useSelector((state) => state.themeData.maintheme);
  const [t] = useTranslation("common");
  
  useEffect(() => {
    
  }, []);

 
  return (
    <div
      style={{
        width: "100vw",
        height: "100vh",
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: maintheme?.primary,
        zIndex: 2147483647,
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "start",
          alignItems: "center",
          width: "100%",
          height: "auto",
          flexDirection: "column",
          marginTop: "30px",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <span
            style={{
              fontFamily: "Cairo-Medium",
              color: "#fff",
              fontSize: "30px",
            }}
          >
            {t("GLOBAL.sorryMessage")}
          </span>
          
          
          
        </div>
      </Box>
    </div>
  );
}
